import { configureStore } from '@reduxjs/toolkit'
import { clientAccountApi } from 'actions/client/client-account-api'
import { clientDosemeterMeasurementApi } from 'actions/client/client-dosemeter-measurement-api'
import { translationApi } from 'actions/translation-api'
import measurementListFilter from 'store/client/slice.measurement-list-filter'
import measurementReportListFilter from 'store/client/slice.measurement-report-list-filter'

const store = configureStore({
	reducer: {
		[clientAccountApi.reducerPath]: clientAccountApi.reducer,
		[clientDosemeterMeasurementApi.reducerPath]: clientDosemeterMeasurementApi.reducer,
		[translationApi.reducerPath]: translationApi.reducer,
		measurementListFilter,
		measurementReportListFilter
	},
	middleware: getDefaultMiddleware => getDefaultMiddleware().concat([
		clientAccountApi.middleware,
		clientDosemeterMeasurementApi.middleware,
		translationApi.middleware
	])
});
export default store;
